import request from "superagent";

import config from "config/config";

export class LoginMethodAPI {
  static async getLoginMethod(username: string) {
    const response = await request
      .post(config.api.loginMethod.post)
      .set("Accept", "application/json")
      .send({
        UserId: username
      });

      return response.body
  }
}
